import { NotFoundPage } from "@climatepartner/components/ErrorPages";
import { Spinner } from "@climatepartner/components/Spinner";
import { ReactElement, Suspense } from "react";
import { Outlet } from "react-router-dom";

import { useFeatureToggles } from "../../shared/feature-flags/use-feature-toggles";
import { useRedirectOnAccountSwitch } from "./shared/use-redirect-on-account-switch";

export {
  ReductionBaselinePage,
  ReductionLandingPage,
  ReductionMeasuresPage,
  ReductionRoadmapPage,
  ReductionScenariosPage,
  ReductionWizardLayout,
} from "./lazy-pages";

export const ReductionRoute = (): ReactElement => {
  const { enabled } = useFeatureToggles("reductionMvp");
  useRedirectOnAccountSwitch();

  if (!enabled) {
    return <NotFoundPage />;
  }

  return (
    <Suspense fallback={<Spinner />}>
      <Outlet />
    </Suspense>
  );
};
